import { useDispatch, useSelector } from "react-redux";
import { selectIsLoggedIn } from "../../../../redux/features/auth/authSlice";
import { useEffect, useState } from "react";
import {
  deleteAdvert,
  getAdverts,
} from "../../../../redux/features/add/addSlice";
import Search from "../../../search/Search";
import { Spinner } from "../../../loader/Loader";
import { AiOutlineEye } from "react-icons/ai";
import { FaEdit, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import { shortenText } from "../../../../utils";
import ReactPaginate from "react-paginate";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import {
  FILTER_BY_SEARCH,
  selectFilteredAdds,
} from "../../../../redux/features/add/addFilterSlice";

const ViewAdds = () => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { adds, isLoading } = useSelector((state) => state.add);
  const filteredAdds = useSelector(selectFilteredAdds);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(getAdverts());
    }
  }, [isLoggedIn, dispatch]);

  const confirmDelete = (id) => {
    confirmAlert({
      title: "Delete Advert",
      message: "Are you sure to delete this adds?.",
      buttons: [
        {
          label: "Delete",
          onClick: () => delAdd(id),
        },
        {
          label: "Cancel",
          //  onClick: () => alert("Click No"),
        },
      ],
    });
  };

  const delAdd = async (id) => {
    await dispatch(deleteAdvert(id));
    await dispatch(getAdverts());
  };

  return (
    <section>
      <div className="container product-list">
        <div className="table">
          <div className="--flex-between --flex-dir-column">
            <span>
              <h2>All Adds</h2>
              <p>
                ~ <b>{adds?.length}</b> Adds found
              </p>
            </span>
            <span>
              <Search
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </span>
          </div>
        </div>

        {isLoading && <Spinner />}

        <div className="table">
          {!isLoading && adds?.length === 0 ? (
            <p>No adds found...</p>
          ) : (
            <table>
              <thead>
                <td>s/n</td>
                <td>link</td>
                <td>Category</td>
                <td>Action</td>
              </thead>

              <tbody>
                {/* {currentItems?.map((post, index) => { */}
                {adds?.map((add, index) => {
                  const { _id, link, category } = add;
                  return (
                    <tr key={_id}>
                      <td>{index + 1}</td>
                      <td>{shortenText(link, 16)}</td>
                      <td>{category}</td>

                      <td className="icons">
                        <span>
                          <Link to="/">
                            <AiOutlineEye size={25} color={"purple"} />
                          </Link>
                        </span>
                        <span>
                          <Link to={`/admin/edit-add/${_id}`}>
                            <FaEdit size={20} color={"green"} />
                          </Link>
                        </span>
                        <span>
                          <FaTrash
                            size={20}
                            color={"red"}
                            onClick={() => confirmDelete(_id)}
                          />
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </section>
  );
};
export default ViewAdds;
